import React from 'react';
import propTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles';

const useStyles = makeStyles(styles);

const BlockedActionDialog = ({ open, onClose, title, body, confirmLabel }) => {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      {title && <DialogTitle disableTypography><Typography variant="h6">{title}</Typography></DialogTitle>}
      <DialogContent>
        {typeof body === 'string' ? <Typography variant="body1">{body}</Typography> : body}
      </DialogContent>
      <DialogActions classes={{ root: classes.actions }}>
        <Button color="primary" variant="outlined" onClick={onClose} disableTouchRipple>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

BlockedActionDialog.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  title: propTypes.node,
  body: propTypes.node.isRequired,
  confirmLabel: propTypes.string,
};

BlockedActionDialog.defaultProps = {
  title: null,
  confirmLabel: 'OK',
};

export default BlockedActionDialog;
